import useTranslate from 'modules/local/useTranslate'
import {useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {notifyOnError} from "../../factory/createErrorEvent";
import {bindQueryParam} from "../../functions/routerHelper";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {event_add_Api, event_claimReward_Api, event_delete_Api, event_edit_Api} from "../../../../apis/event";


export const useEventApi = ({
                                notifyListeners = {
                                    onCreated: undefined,
                                    onUpdated: undefined,
                                    onDeleted: undefined,
                                    onClaimedReward: undefined,
                                },
                            }) => {
    const t = useTranslate()
    const [action, setAction] = useState({type: undefined, value: undefined})

    const {
        onCreated = NullAsDefault,
        onUpdated = NullAsDefault,
        onDeleted = NullAsDefault,
        onClaimedReward = NullAsDefault,
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)

    const {handleAsyncAction: onCreate, ...asyncCreating} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: event_add_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onCreated(result, data)
        },
    })

    const {handleAsyncAction: onUpdate, ...asyncUpdating} = useAsyncAction({
        onError,
        apiInfo: event_edit_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onUpdated(result, data)
        },
    })

    const {handleAsyncAction: onDelete, ...asyncDeleting} = useAsyncAction({
        onError,
        apiInfo: event_delete_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onDeleted(result, data)
        },
    })


    const {handleAsyncAction: onClaimReward, ...asyncClaimingReward} = useAsyncAction({
        onError,
        apiInfo: event_claimReward_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            onClaimedReward(result, data)
        },
    })


    return {
        onCreate,
        onUpdate,
        onDelete,
        onClaimReward,
        asyncCreating,
        asyncUpdating,
        asyncDeleting,
        asyncClaimingReward
    }
}



